import React from "react";
import { ChevronDown } from "lucide-react";
export const Hero = () => {
  const scrollToSignup = () => {
    const element = document.getElementById("signup");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return <section className="w-full min-h-[90vh] bg-white flex items-center justify-center" data-id="element-35">
      <div className="max-w-4xl mx-auto px-4 py-16 text-center" data-id="element-36">
        <div className="mb-4" data-id="element-37">
          <span className="inline-block px-4 py-2 bg-emerald-50 text-emerald-600 rounded-full text-sm font-medium mb-4" data-id="element-38">
            Get Paid For Your LinkedIn Influence
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-39">
          Turn Your LinkedIn Into a
          <br data-id="element-40" />
          <span className="relative inline-block mt-2" data-id="element-41">
            <span className="relative z-10 bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent" data-id="element-42">
              Revenue Stream
            </span>
            <span className="absolute bottom-1 left-0 w-full h-3 bg-gradient-to-r from-teal-200 to-emerald-200 -z-10 opacity-50 transform -rotate-1" data-id="element-43"></span>
          </span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-44">
          Your LinkedIn influence is valuable. Get paid to endorse brands you
          believe in, grow your professional network, and keep full control. No
          corporate speak, just authentic connections.
        </p>
        <div className="flex flex-col items-center space-y-4" data-id="element-45">
          <button onClick={scrollToSignup} className="inline-flex items-center px-8 py-4 text-lg font-semibold text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer" data-id="element-46">
            Start Earning
            <ChevronDown className="ml-2 h-5 w-5" data-id="element-47" />
          </button>
          <p className="text-sm text-gray-500" data-id="element-48">
            Pick your brands • Grow your network • Get paid monthly
          </p>
        </div>
      </div>
    </section>;
};